export const translationForPagesKeys = {
  account: {
    pageTitle: 'Account',
    tabSettings: 'Account Settings',
    tabSubscription: 'Subscription',
    sectionInfo: {
      title: 'Account info',
      language: 'Language',
      currency: 'Currency',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      editAccountInfo: 'Edit Account info',
    },
    sectionUsage: {
      title: 'Account usage',
      amountOfQRsCreated: '{{totalQRCodes}} of {{maxQRCodes}} QR codes created',
      amountOfScans: '{{totalScans}} of {{maxScans}} scans',
    },
    sectionEmailPreferences: {
      title: 'Email preferences',
      accountNotifications: 'Account notifications',
      qrNotifications: 'QR notifications',
      marketing: 'Marketing',
    },
    sectionQRPreferences: {
      title: 'QR code preferences',
      useGPSBasedLocation: 'Use GPS based location for QR codes',
    },
    sectionSecurity: {
      title: 'Security',
    },
    sectionManage: {
      title: 'Manage your account',
      deleteAccount: 'Delete account',
      deleteAccountWarningTitle: 'Are you sure you want to delete you account?',
      deleteAccountWarningDescription: 'Account cannot be restored, all data will be automatically deleted.',
    },
    changePassword: {
      title: 'Change password',
      recommendations: 'Keep your data safe by creating a password that is complex and long enough.',
      newPassword: 'New password',
      createNewPassword: 'Create new password',
      confirmNewPassword: 'Confirm new password',
    },
  },
  createQRCode: {
    pageTitle: 'Create QR Codes',
  },
  dashboard: {
    pageTitle: 'Dashboard',
  },
  myQRCodes: {
    pageTitle: 'My QR Codes',
    createQRCode: 'Create QR Code',
    viewAllQRCodes: 'View All QR Codes',
  },
  templates: {
    pageTitle: 'Templates',
    createTemplate: 'Create Template',
    viewAllTemplates: 'View All Templates',
  },
  qrAnalytics: {
    sectionTitle: 'QR codes analytics',
    totalQRCodes: 'Total QR codes',
    totalScans: 'Total scans',
    totalUsers: 'Total users',
  },
} as const;
